export default __webpack_public_path__ + "static/media/indep.9707bb2c.svg";